import script from "./ModalAiSetupConfigSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAiSetupConfigSection.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAiSetupConfigSection.vue?vue&type=style&index=0&id=8796253a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8796253a"]])

export default __exports__